import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import { services } from "../Data";

const Services = ({ isSlider = true, excludeSlug = "", desc = "", basePath = "/services", sliderHeading="" }) => {

  // SECTION STAGGER
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.16,
      },
    },
  };

  // PREMIUM FADE
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 45,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.95,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  // CARD ANIMATION
  const cardVariant = {
    hidden: {
      opacity: 0,
      y: 50,
      scale: 0.96,
    },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        delay: i * 0.08,
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1],
      },
    }),
  };
const filteredServices = excludeSlug
  ? services.filter(
      (item) => item.slug !== excludeSlug
    )
  : services;
  return (
    <>
      <section className="services-section">
        <div className="container">

        {/* TOP */}

        <motion.div
          className="services-top"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
        >

          <motion.h2
            className="section-heading center-heading"
            variants={fadeUp}
          >
            { sliderHeading || (
           <>Our Settlement <span>Services</span></> )}
          </motion.h2>

          <motion.div
            className="heading-line"
            initial={{
              width: 0,
              opacity: 0,
            }}
            whileInView={{
              width: "120px",
              opacity: 1,
            }}
            transition={{
              duration: 1,
              ease: [0.22, 1, 0.36, 1],
            }}
            viewport={{
              once: true,
            }}
          />

          <motion.p
            className="section-text center-text"
            variants={fadeUp}
          >
            {desc || "Professional settlement solutions for residential, commercial, and property transfers across Perth & Western Australia handled with accuracy, transparency, and care."}
          </motion.p>

        </motion.div>

        {/* SLIDER VERSION */}

        {isSlider ? (

          <motion.div
            initial={{
              opacity: 0,
              y: 50,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            transition={{
              duration: 1,
              ease: [0.22, 1, 0.36, 1],
            }}
            viewport={{
              once: true,
              amount: 0.15,
            }}
          >

            <Swiper
  slidesPerView={4}
  spaceBetween={28}
  loop={true}
  speed={1200}
  autoplay={{
    delay: 3000,
    disableOnInteraction: false,
  }}
  pagination={{
    clickable: true,
  }}
  breakpoints={{
    320: {
      slidesPerView: 1,
      spaceBetween: 16,
    },
    576: {
      slidesPerView: 1,
      spaceBetween: 18,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
    1280: {
      slidesPerView: 4,
      spaceBetween: 28,
    },
  }}
  modules={[Pagination, Autoplay]}
  className="services-swiper"
>

              {filteredServices.map((item, i) => (

                <SwiperSlide key={i}>

                  <motion.div
                    className="service-card"
                    custom={i}
                    variants={cardVariant}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{
                      once: true,
                      amount: 0.2,
                    }}
                    transition={{
                      duration: 0.4,
                      ease: [0.22, 1, 0.36, 1],
                    }}
                  >

                    <motion.div
                      className="service-icon-wrap"
                      whileHover={{
                        scale: 1.08,
                        rotate: -3,
                      }}
                      transition={{
                        duration: 0.35,
                      }}
                    >
                      <img
                        src={item.icon}
                        alt={`${item.title} | LDL Settlement Services`}
                      />
                    </motion.div>

                    <h3 className="card-heading">
                      {item.title}
                    </h3>

                    <p className="section-text">
                      {item.desc}
                    </p>

                    {/* BUTTON */}

                  <Link
  className="service-btn"
  to={`${basePath}/${item.slug}`}
>
  <span className="default-arrow">
    ❯
  </span>

  <span className="hover-text">
    Know More
  </span>
</Link>

                  </motion.div>

                </SwiperSlide>

              ))}

            </Swiper>

          </motion.div>

        ) : (

          /* GRID VERSION */

          <motion.div
            className="services-grid"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.15,
            }}
          >

            {services.map((item, i) => (

              <motion.div
                className="service-card"
                key={i}
                custom={i}
                variants={cardVariant}
                whileHover={{
                  y: -12,
                }}
                transition={{
                  duration: 0.4,
                  ease: [0.22, 1, 0.36, 1],
                }}
              >

                <motion.div
                  className="service-icon-wrap"
                  whileHover={{
                    scale: 1.08,
                    rotate: -3,
                  }}
                  transition={{
                    duration: 0.35,
                  }}
                >
                  <img
                    src={item.icon}
                    alt={item.title}
                  />
                </motion.div>

                <h3 className="card-heading">
                  {item.title}
                </h3>

                <p className="section-text">
                  {item.desc}
                </p>
 
               <Link
  className="service-btn"
  to={`${basePath}/${item.slug}`}
>
  <span className="default-arrow">
    ❯
  </span>

  <span className="hover-text">
    Know More
  </span>
</Link>

              </motion.div>

            ))}

          </motion.div>

        )}
</div>
      </section>
    </>
  );
};

export default Services;